  <!-- Sidebar Content starts -->
<div id="sidebar-wrapper" class="sidebar">
        <!-- Sidebar Header starts -->
        <div class="brand-logo">
            <img src="assets/images/logo_icon2.png" style="width: 50px; height: 50px;" class="logo-icon" alt="logo icon">
            <h5 class="logo-text" style="cursor: pointer;" (click)="viewDashboard()"><B>Nagar Setu Kota</B></h5>
            <div class="close-btn" (click)="toggleSidebar()"><i class="zmdi zmdi-close"></i></div>
        </div>
      
        <!-- Sidebar Header Ends -->

        <!-- <div class="form-inline">
            <div class="input-group" data-widget="sidebar-search">
              <input class="form-control form-control-sidebar" type="search" placeholder="Search" aria-label="Search">
              <div class="input-group-append">
                <button class="btn btn-sidebar">
                  <i class="fa fa-search fa-fw"></i>
                </button>
              </div>
            </div>
          </div> -->
          
    <div class="sidebar-content"  [perfectScrollbar]>
        <ul class="navigation">   
            <div class="search-box pb-1" >
                <i class="zmdi zmdi-search search-icon"></i>
                <input class="form-control" type="search" name="searchText" [(ngModel)]="searchText" (input)="onSearchMenu()" placeholder="Start searching...">
            </div>

            <!-- First level menu -->
            <!-- <li *ngFor="let menuItem of filteredMenuItems"
                [ngClass]="[menuItem.class]"
                [routerLinkActive]="menuItem.submenu.length != 0 ? '' : 'active'"
                [routerLinkActiveOptions]="{exact: true}"> -->
            <li *ngFor="let menuItem of filteredMenuItems"
                [ngClass]="{'sub': menuItem.class === 'sub', 'active': isModuleActive(menuItem)}">  

                <a [routerLink]="menuItem.class === '' ? [menuItem.path] : null"
                *ngIf="!menuItem.isExternalLink; else externalLinkBlock">

                    <i [ngClass]="[menuItem.icon]"></i>
                    <span class="menu-title">{{menuItem.title}}</span>
                    <span *ngIf="menuItem.badge != ''" [ngClass]="[menuItem.badgeClass]">{{menuItem.badge}}</span>
                </a>

                <ng-template #externalLinkBlock>
                    <a [href]="[menuItem.path]" target="_blank">
                        <i [ngClass]="[menuItem.icon]"></i>
                        <span class="menu-title">{{menuItem.title}}</span>
                        <span *ngIf="menuItem.badge != '' "
                        [ngClass]="[menuItem.badgeClass]">{{menuItem.badge}}</span>
                    </a>
                </ng-template>

                <!-- Second level menu -->
                <ul class="menu-content" *ngIf="menuItem.submenu.length > 0">

                    <!-- <li *ngFor="let menuSubItem of menuItem.submenu"
                        [routerLinkActive]="menuSubItem.submenu.length > 0 ? '' : 'active'"
                        [ngClass]="[menuSubItem.class]"> -->
                    <li *ngFor="let menuSubItem of menuItem.submenu"
                        [ngClass]="{'active': isSubMenuActive(menuSubItem)}">

                        <!-- ✅ UPDATED LINE -->
                        <a href="javascript:void(0)" (click)="openMenu(menuSubItem)" 
                            *ngIf="!menuSubItem.isExternalLink; else externalSubLinkBlock">
                            <i [ngClass]="[menuSubItem.icon]"></i>
                            <span class="sub-menu-title">{{menuSubItem.title}}</span>
                            <span *ngIf="menuSubItem.badge != '' " [ngClass]="[menuSubItem.badgeClass]">{{menuSubItem.badge}}</span>
                        </a>
                        <!-- <a
                            [routerLink]="[menuSubItem.path]"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                            *ngIf="!menuSubItem.isExternalLink; else externalSubLinkBlock">

                            <i [ngClass]="[menuSubItem.icon]"></i>

                            <span class="sub-menu-title">
                                {{ menuSubItem.title }}
                            </span>

                            <span
                                *ngIf="menuSubItem.badge != ''"
                                [ngClass]="[menuSubItem.badgeClass]">
                                {{ menuSubItem.badge }}
                            </span>

                        </a> -->
                        <!-- <a [routerLink]="menuSubItem.path"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                            (click)="openMenu(menuSubItem)"
                            *ngIf="!menuSubItem.isExternalLink; else externalSubLinkBlock">

                            <i [ngClass]="[menuSubItem.icon]"></i>
                            <span class="sub-menu-title">{{menuSubItem.title}}</span>
                        </a> -->

                        <ng-template #externalSubLinkBlock>
                            <a [href]="[menuSubItem.path]" target="_blank">
                                <i [ngClass]="[menuSubItem.icon]"></i>
                                <span class="sub-menu-title">{{menuSubItem.title}}</span>
                                <span *ngIf="menuSubItem.badge != '' "
                                    [ngClass]="[menuSubItem.badgeClass]">{{menuSubItem.badge}}</span>
                            </a>
                        </ng-template>

                        <!-- Third level menu (unchanged) -->
                        <ul class="menu-content" *ngIf="menuSubItem.submenu.length > 0">

                            <li *ngFor="let menuSubsubItem of menuSubItem.submenu"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}"
                                [ngClass]="[menuSubsubItem.class]">

                                <a [routerLink]="[menuSubsubItem.path]"
                                *ngIf="!menuSubsubItem.isExternalLink; else externalSubSubLinkBlock">

                                    <i [ngClass]="[menuSubsubItem.icon]"></i>
                                    <span class="sub-menu-title">{{menuSubsubItem.title}}</span>
                                    <span *ngIf="menuSubsubItem.badge != '' "
                                        [ngClass]="[menuSubsubItem.badgeClass]">{{menuSubsubItem.badge}}</span>
                                </a>

                                <ng-template #externalSubSubLinkBlock>
                                    <a [href]="[menuSubsubItem.path]" target="_blank">
                                        <i [ngClass]="[menuSubsubItem.icon]"></i>
                                        <span class="sub-menu-title">{{menuSubsubItem.title}}</span>
                                        <span *ngIf="menuSubsubItem.badge != '' "
                                            [ngClass]="[menuSubsubItem.badgeClass]">{{menuSubsubItem.badge}}</span>
                                    </a>
                                </ng-template>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
    <!-- Sidebar Content Ends -->
</div>
<style>
   .search-box {
        position: relative;
        width: 100%;
    }

    .search-icon {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 20px;
        color: #6b7280;
        z-index: 2;
        pointer-events: none;
    }

    .search-box .form-control {
        padding-left: 36px;
        height: 42px;
    }

    .nav-collapsed .search-box {
        width: 42px;
        height: 42px;
        margin: 0 auto;
        padding: 0 !important;
    }

    .nav-collapsed .search-box .form-control {
        width: 42px;
        height: 42px;
        padding: 0;
        border-radius: 50%;
        cursor: pointer;
        color: transparent;
        text-indent: -9999px;
    }

    .nav-collapsed .search-box .search-icon {
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 20px;
        color: #6b7280;
    }

    .nav-collapsed .search-box:hover .form-control {
        background-color: #f3f4f6;
    }

    .nav-collapsed .search-box:hover .search-icon {
        color: #374151;
    }
</style>